export default __webpack_public_path__ + "static/media/link.fa4657f6.svg";